import React, { useEffect, useState } from 'react';
import IconMoreOptions from '@deprecated-ui/common/IconMoreOptions';
import Popover from '@deprecated-ui/common/Popover';
import Button from '@deprecated-ui/common/Button';
import { useDispatch, useSelector } from 'react-redux';
import valuationSlice, {
  valuationEffects,
  valuationSelectors,
} from 'features/valuation/slice';
import { effects as valuationWidgetEffects } from 'global/MainLayout/SideWidget/Valuation/slice';
import handleErrorMessageAPI from 'global/AlertErrorMessage';
import SUCCESS_MESSAGE from 'constants/successMessage';
import DATA_CY from 'constants/data-cy';
import Modal from '../Modal';
import {
  SPopoverContent,
  STitleLabel,
  STitleOptions,
  STitleWrapper,
} from './styled';
import PopoverValuation from './PopoverValuation';

const ValuationHeader = () => {
  const [isModalEditVisible, setIsModalEditVisible] = useState<boolean>(false);
  // prettier-ignore
  const [isModalDeleteVisible, setIsModalDeleteVisible] = useState<boolean>(false);

  const {
    valuationDetail,
    valuationResult,
    valuationSymbol,
    valuationCreateTemplateResult,
    metric,
    note,
  } = useSelector(valuationSelectors);

  const {
    updateValuationDetailTemplate,
    getValuationDetailTemplate,
    deleteValuationDetailTemplate,
  } = valuationEffects;

  const {
    resetValuationDetail,
    resetValuationResult,
    resetTemplateResult,
    resetValuationSymbol,
  } = valuationSlice.actions;

  const { getValuationTemplate: getValuationList } = valuationWidgetEffects;

  const dispatch = useDispatch();

  useEffect(() => {
    // Did mount
    dispatch(getValuationList());
  }, [dispatch]);

  const onClickButtonPopover = (type: string) => {
    if (type === 'edit') setIsModalEditVisible(true);
    if (type === 'delete') setIsModalDeleteVisible(true);
  };

  const hideModal = () => {
    setIsModalEditVisible(false);
    setIsModalDeleteVisible(false);
  };

  const generateResult = () => {
    const { data: dataValuationResult } = valuationResult;
    const normalizeData = JSON.parse(JSON.stringify(dataValuationResult));

    delete normalizeData.symbol;
    delete normalizeData.symbol_2;
    delete normalizeData.symbol_3;
    delete normalizeData.country;
    delete normalizeData.exchange;

    return Object.keys(normalizeData).map((el) => ({
      name: el,
      value: normalizeData[el],
    }));
  };

  const getValuationDetail = () => {
    const { data: dataCreate } = valuationCreateTemplateResult;
    const { data: dataValuation } = valuationDetail;

    const id = dataValuation?.valuation?.id || dataCreate?.id;

    // @ts-ignore
    dispatch(getValuationDetailTemplate(id));
  };

  const updateValuation = async (newValuationName: string) => {
    const { data: dataCreate } = valuationCreateTemplateResult;

    const { data: dataValuation } = valuationDetail;

    const result = generateResult();

    const payload = {
      name: newValuationName,
      note,
      metric: JSON.stringify(metric),
      result: JSON.stringify(result),
    };

    const templateID = dataValuation?.valuation?.id || dataCreate?.id;

    const updated = await dispatch(
      updateValuationDetailTemplate({ payload, templateID }),
    );
    // @ts-ignore
    const { error, message } = updated.payload;

    if (!error) {
      handleErrorMessageAPI(message, SUCCESS_MESSAGE.ALERT_GREEN);
      hideModal();
      getValuationDetail();
      dispatch(getValuationList());
    }
  };

  const deleteValuation = async () => {
    const { data: dataCreate } = valuationCreateTemplateResult;

    const { data: dataValuation } = valuationDetail;

    const templateID = dataValuation?.valuation?.id || dataCreate?.id;

    // @ts-ignore
    const del = await dispatch(deleteValuationDetailTemplate(templateID));

    // @ts-ignore
    const { error } = del.payload;
    if (!error) {
      // Reset UI
      dispatch(resetValuationDetail());
      dispatch(resetValuationResult());
      dispatch(resetTemplateResult());
      dispatch(resetValuationSymbol());

      hideModal();

      // Show feedback
      const name = valuationDetail?.data?.valuation?.name || '';
      handleErrorMessageAPI(
        `Template ${name} has been deleted`,
        SUCCESS_MESSAGE.ALERT_GREEN,
      );

      // Get list
      dispatch(getValuationList());
    }
  };

  const content = (
    <SPopoverContent>
      <Button
        width="100%"
        type="borderless"
        onClick={() => {
          onClickButtonPopover('edit');
        }}
      >
        Edit
      </Button>
      <Button
        width="100%"
        type="borderless"
        onClick={() => {
          onClickButtonPopover('delete');
        }}
      >
        Delete
      </Button>
    </SPopoverContent>
  );

  const headerOptions = (
    <STitleOptions>
      <STitleWrapper>
        <PopoverValuation>
          <span data-cy={DATA_CY.VALUATION.HEADER_TITLE}>
            {valuationDetail.data?.valuation?.name}
          </span>
        </PopoverValuation>
        <Popover
          zIndex={1}
          content={content}
          trigger="click"
          placement="bottomRight"
          overlayStyle={{ width: '100px' }}
        >
          <div data-cy={DATA_CY.VALUATION.HEADER_MORE_BUTTON}>
            <IconMoreOptions vertical />
          </div>
        </Popover>
      </STitleWrapper>
      <STitleWrapper>
        {`Created on ${valuationDetail.data?.valuation?.created}`}
      </STitleWrapper>
    </STitleOptions>
  );

  if (Object.keys(valuationDetail.data).length) {
    return (
      <>
        {headerOptions}
        <Modal
          isVisible={isModalEditVisible}
          cancelText="CANCEL"
          okText="UPDATE"
          modalTitle="Update Valuation Name"
          onClickCancel={hideModal}
          onClickOk={updateValuation}
          initValuationName={valuationDetail.data?.valuation?.name}
        />

        <Modal
          isVisible={isModalDeleteVisible}
          cancelText="CANCEL"
          okText="DELETE"
          modalTitle="Delete Valuation"
          onClickCancel={hideModal}
          onClickOk={deleteValuation}
          isDeleteMode
          initValuationName={valuationDetail.data?.valuation?.name}
        />
      </>
    );
  }

  return (
    <STitleLabel>
      <PopoverValuation>Valuation Tools</PopoverValuation>
    </STitleLabel>
  );
};
export default ValuationHeader;
